import { brands } from '../data/products';
import ImageWithSkeleton from './ImageWithSkeleton';

export default function BrandsSection() {
  return (
    <div className="py-8 c bg-white">
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex flex-wrap items-center justify-center gap-8">
          {brands.map((brand, i) => (
            <a key={i} href="#" className="opacity-60 hover:opacity-100 transition-opacity">
              <ImageWithSkeleton
                src={brand}
                alt={`brand ${i + 1}`}
                containerClassName="h-12 w-24"
                className="h-12 object-contain grayscale hover:grayscale-0 transition-all"
              />
            </a>
          ))}
        </div>
      </div>
    </div>
  );
}
